var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlicedPattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1368,
    height: 307,
    viewBox: "0 0 1368 307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.868,
    y1: 0.237,
    x2: 0.043,
    y2: 0.762,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68001e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d90032"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 1368,
    height: 307,
    rx: 20,
    transform: "translate(0 -0.296)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_35",
    "data-name": "Mask Group 35",
    transform: "translate(0 0.296)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(0 -735.881)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M579.909,259.018l496.734,333.463V481.326L579.909,147.864Z",
    transform: "translate(0 74.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M0,0V111.152L496.734,444.615h83.175V333.461H496.734Z",
    transform: "translate(0 0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M579.909,406.882l496.734,333.463V629.192L579.909,295.729Z",
    transform: "translate(0 148.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M579.909,554.748,1076.643,888.21V777.056L579.909,443.595Z",
    transform: "translate(0 223.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M579.909,702.614l496.734,333.463V924.922L579.909,591.459Z",
    transform: "translate(0 297.773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M579.909,850.478l496.734,333.463V1072.787L579.909,739.325Z",
    transform: "translate(0 372.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M579.909,998.343l496.734,333.463V1220.651L579.909,887.19Z",
    transform: "translate(0 446.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M0,259.018,496.734,592.481h83.175V481.326H496.734L0,147.864Z",
    transform: "translate(0 74.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M0,406.882,496.734,740.345h83.175V629.192H496.734L0,295.729Z",
    transform: "translate(0 148.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M0,554.748,496.734,888.21h83.175V777.056H496.734L0,443.595Z",
    transform: "translate(0 223.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M0,702.614l496.734,333.463h83.175V924.922H496.734L0,591.459Z",
    transform: "translate(0 297.773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M0,850.478,496.734,1183.94h83.175V1072.787H496.734L0,739.325Z",
    transform: "translate(0 372.216)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlicedPattern);
export default __webpack_public_path__ + "static/media/sliced_pattern.daff24efa7784b90e6cca6f5afad5438.svg";
export { ForwardRef as ReactComponent };